module.exports = __webpack_public_path__ + "static/media/Promotional offer Press_8col X 5in_Output [Converted]-02.8f502184.jpg";